import { Box } from '@mui/material';
import { Dispatch, FC, SetStateAction } from 'react';
import PcapFilesFilters from './PcapFilesFilters';
import { MRT_RowData, MRT_TableInstance } from 'material-react-table';
import DownloadIcon from '@mui/icons-material/Download';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import ModalErrorContainer from '@shared/components/modals/ModalErrorContainer';
import { LoadingButton } from '@mui/lab';
import { utmsButtonSx } from '@shared/constants/otherConstants';
import { downloadPcapFileRequest, downloadPcapFileReset } from '../store';
import { selectDownloadPcapFileError, selectDownloadPcapFileStatus } from '../store/selectors';
import { RequestStatusEnum } from '@shared/types';

export interface PcapFilesListToolbarProps {
    globalFilter: string;
    setGlobalFilter: Dispatch<SetStateAction<string>>;
    table: MRT_TableInstance<MRT_RowData>;
    dialogMode: boolean;
    selectedPcapFileId: number | null;
}

const PcapFilesListToolbar: FC<PcapFilesListToolbarProps> = ({
    globalFilter,
    setGlobalFilter,
    table,
    dialogMode,
    selectedPcapFileId,
}) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const downloadPcapFileStatus = useSelector(selectDownloadPcapFileStatus);
    const isLoadingPcapFile = downloadPcapFileStatus === RequestStatusEnum.Loading;

    const handleDownloadPcapFile = () => {
        selectedPcapFileId && dispatch(downloadPcapFileRequest(selectedPcapFileId));
    };
    return (
        <>
            <Box>
                {!dialogMode && (
                    <LoadingButton
                        loadingPosition="start"
                        loading={isLoadingPcapFile}
                        startIcon={<DownloadIcon />}
                        onClick={handleDownloadPcapFile}
                        sx={utmsButtonSx}
                        disabled={!selectedPcapFileId}
                    >
                        {t('download')}
                    </LoadingButton>
                )}
                <PcapFilesFilters globalFilter={globalFilter} setGlobalFilter={setGlobalFilter} table={table} />
            </Box>
            {downloadPcapFileStatus === RequestStatusEnum.Error && (
                <ModalErrorContainer
                    object={t('file_r')}
                    action={t('download_p')}
                    resetActionCallback={downloadPcapFileReset}
                    errorSelector={selectDownloadPcapFileError}
                />
            )}
        </>
    );
};

export default PcapFilesListToolbar;
